import { INavLink } from 'shared/components/navigation-bar/nav-link.interface';
import { AdminPrivileges } from 'shared/constants/privileges';
export const ADMIN_NAV_LINKS: INavLink[] = [
	{
		link: '/deals',
		title: 'admin.pages.deal-list.title',
		icon: 'icons/nav-links/documents',
		dsIcon: false,
		privileges: [],
	},
	{
		link: '/calculations',
		title: 'admin.pages.lead-management.menu-title',
		icon: 'icons/nav-links/headphones',
		dsIcon: false,
		privileges: [],
	},
	{
		link: '/customers',
		title: 'admin.pages.customers-view.title',
		icon: 'icons/device-user/users',
		dsIcon: true,
		privileges: [AdminPrivileges.AdminGetCustomerOverview],
	},
	{
		link: '/unsecured-loans',
		title: 'admin.pages.unsecured-loan-list.title',
		icon: 'icons/nav-links/coins',
		dsIcon: false,
		privileges: [AdminPrivileges.AdminGetLoanApplications],
	},
	{
		link: '/admin-daily-tasks',
		title: 'admin.pages.daily-tasks.title',
		icon: 'icons/nav-links/todo',
		dsIcon: false,
		privileges: [],
	},
	{
		link: '/calculator-templates',
		title: 'admin.pages.calculator-templates.title',
		icon: 'icons/action/settings',
		dsIcon: true,
		privileges: [AdminPrivileges.AdminGetCalculatorTemplate],
	},
	{
		link: '/system-event-log-management',
		title: 'admin.pages.system-event-log-management.title',
		icon: 'icons/extra-unique/book',
		dsIcon: true,
		privileges: [AdminPrivileges.AdminGetSystemEventLogs],
	},
];
